<template>
  <div class="button-group">
    <slot name="default" />
  </div>
</template>

<script>
export default {
  name: 'TgButtonGroup',
};
</script>

<style scoped>
@media screen and (min-width: 570px) {
  .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
    justify-content: flex-start;
  }
}
</style>
